<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BLACKLIST.ADD.SHOW"
    :handler="() => openEditor()"
  />

  <DialogComponent ref="modal" type="modal" noInnerPadding hideCloseButton>
    <div class="w-full h-full flex flex-col overflow-auto p-4 bg-slate-50">
      <div class="mobile-status-padding"></div>

      <!-- HEADER -->
      <div class="flex justify-between items-center mb-6">
        <button
          class="w-12 h-12 p-3 rounded-full bg-slate-200"
          @click="() => $refs.modal.hide()"
        >
          <ColorImg
            class="w-full h-full bg-primary -rotate-90"
            src="/images/all/arrow-up.svg"
          />
        </button>
        <h2 class="text-2xl font-semibold text-primary">
          Bloquer un ID
        </h2>
        <div class="w-12"></div>
      </div>

      <!-- FORM -->
      <div class="flex-1 space-y-4">

        <!-- Player ID -->
        <div class="bg-white rounded-xl p-4">
          <label class="block mb-2 text-sm font-medium text-gray-700">
            ID Joueur <span class="text-red-500">*</span>
          </label>
          <input
            v-model="form.playerId"
            class="inputComponent w-full font-mono"
            placeholder="Ex: 410915221"
            type="text"
            inputmode="numeric"
          />
          <p class="text-xs text-gray-400 mt-1">L'identifiant unique du joueur sur la plateforme de paris.</p>
        </div>



        <!-- Currency -->
        <div class="bg-white rounded-xl p-4">
          <label class="block mb-2 text-sm font-medium text-gray-700">
            Devise <span class="text-red-500">*</span>
          </label>
          <div class="flex gap-3">
            <label
              class="flex-1 flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition-all"
              :class="form.currency === 'xof' ? 'border-primary bg-primary/5' : 'border-slate-200 hover:border-slate-300'"
            >
              <input v-model="form.currency" type="radio" value="xof" class="sr-only" />
              <div class="flex-1">
                <p class="font-semibold text-sm text-slate-800">XOF</p>
                <p class="text-xs text-slate-400">Franc CFA BCEAO</p>
              </div>
              <div
                class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
                :class="form.currency === 'xof' ? 'border-primary bg-primary' : 'border-slate-300'"
              >
                <div v-if="form.currency === 'xof'" class="w-2 h-2 rounded-full bg-white"></div>
              </div>
            </label>

            <label
              class="flex-1 flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition-all"
              :class="form.currency === 'xaf' ? 'border-primary bg-primary/5' : 'border-slate-200 hover:border-slate-300'"
            >
              <input v-model="form.currency" type="radio" value="xaf" class="sr-only" />
              <div class="flex-1">
                <p class="font-semibold text-sm text-slate-800">XAF</p>
                <p class="text-xs text-slate-400">Franc CFA BEAC (Gabon)</p>
              </div>
              <div
                class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all"
                :class="form.currency === 'xaf' ? 'border-primary bg-primary' : 'border-slate-300'"
              >
                <div v-if="form.currency === 'xaf'" class="w-2 h-2 rounded-full bg-white"></div>
              </div>
            </label>
          </div>
        </div>

        <!-- Error -->
        <div
          v-if="error"
          class="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-600"
        >
          {{ error }}
        </div>
      </div>

      <!-- ACTIONS -->
      <div class="grid grid-cols-2 gap-3 mt-6 pt-4 border-t border-gray-200">
        <button
          class="px-6 py-3 rounded-xl bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition-all"
          @click="() => $refs.modal.hide()"
        >
          Annuler
        </button>
        <button
          class="px-6 py-3 rounded-xl bg-red-600 text-white font-medium hover:bg-red-700 transition-all flex items-center justify-center gap-2"
          :class="{ 'opacity-50 pointer-events-none': isSubmitting }"
          @click="submit"
        >
          <svg v-if="isSubmitting" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          {{ isSubmitting ? 'Blocage...' : 'Bloquer' }}
        </button>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
export default {
  name: 'BlacklistEditor',



  data() {
    return {
      isSubmitting: false,
      error: null,
      form: {
        playerId: '',
        service: window.lacasaeBettingServiceName,
        currency: 'xof'
      }
    };
  },

  mounted() {
    this.$bus.on(this.$constants.EVENTS.BLACKLIST.ADD.SUCCESS, () => {
      this.isSubmitting = false;
      this.$refs.modal.hide();
      this.resetForm();
    });
    this.$bus.on(this.$constants.EVENTS.BLACKLIST.ADD.ERROR, (err) => {
      this.isSubmitting = false;
      this.error = err?.message || 'Une erreur est survenue.';
    });
  },

  methods: {
    openEditor() {
      this.resetForm();
      this.form.service = window.lacasaeBettingServiceName;
      this.$refs.modal.show();
    },

    resetForm() {
      this.form = { playerId: '', service: window.lacasaeBettingServiceName, currency: 'xof' };
      this.error = null;
      this.isSubmitting = false;
    },

    submit() {
      this.error = null;

      if (!this.form.playerId?.trim()) {
        this.error = "Veuillez saisir l'ID du joueur.";
        return;
      }
      if (!this.form.service) {
        this.error = 'Veuillez sélectionner un service.';
        return;
      }
      if (!this.form.currency) {
        this.error = 'Veuillez sélectionner une devise.';
        return;
      }

      this.isSubmitting = true;
      this.$bus.emit(this.$constants.EVENTS.BLACKLIST.ADD.SUBMIT, {
        playerId: this.form.playerId.trim(),
        service: this.form.service,
        currency: this.form.currency
      });
    }
  }
};
</script>
